import React, { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import moment from 'moment-timezone';
import { Rating } from 'semantic-ui-react';
import QualificationResponses from '../../QualificationResponses';
import MeetingModal from '../../../Meetings/MeetingModal';
import CustomLink from '../../../CustomLink';
import BonusDisplay from '../../../Transactions/BonusDisplay';
import { QUALTRICS_SURVEY_RESPONSE_URL } from '../../../../constants/qualtrics';
import { SURVEY_RESPONSES } from '../../../../queries/job';
import DataContext from '../../../../contexts/DataContext';
import Security from '../../../../utils/Security';

const JobInformation = ({ job }) => {
  const { user } = useContext(DataContext);
  const [fetchSurveyResponses] = useLazyQuery(SURVEY_RESPONSES, {
    variables: { id: job.id },
  });
  const fetchAndViewSurveyResponses = () => {
    fetchSurveyResponses();
    window.open(
      `${QUALTRICS_SURVEY_RESPONSE_URL}RID=${job.qualtricsResponse.responseId}&SID=${job.project.qualtricsSurvey.surveyId}`,
      '_blank',
    );
  };
  const isDecibio = Security.isDecibio();
  const isSuperUser = Security.isSuperUser();
  return (
    <div>
      <div className="information">
        {!!job.ratingOnExpert && (
          <Rating
            icon="star"
            rating={job.ratingOnExpert}
            maxRating={5}
            disabled
          />
        )}
      </div>
      <div className="information">
        {(job.qualificationResponses?.length > 0
          || job.project.requiresProfessionalRegistration) && (
          <div className="link">
            <QualificationResponses job={job}>
              <div className="span-link" role="link">
                View Qualification Responses
              </div>
            </QualificationResponses>
          </div>
        )}
        <div className="link">
          {job.project.type === 'Interview' ? (
            <MeetingModal job={job}>
              <div className="span-link">
                {job.meetingAt && moment.tz(job.meetingAt, user.timeZone).format('ddd, M/D/YY hh:mm a z')}
              </div>
            </MeetingModal>
          ) : job.qualtricsResponse?.responseId && (
            <CustomLink
              className="span-link"
              onClick={fetchAndViewSurveyResponses}
            >
              View Survey Responses
            </CustomLink>
          )}
        </div>
      </div>
      {(isDecibio || isSuperUser) && (
        <div className="information">
          {job.bonuses?.length > 0 && <BonusDisplay user={user} job={job} />}
        </div>
      )}
    </div>
  );
};

export default JobInformation;
